import React from 'react';
import { PageHero } from '../components/PageUI';

const ObrigadoContatoPage = () => (
  <div>
    <PageHero
      eyebrow="Obrigado"
      title="Recebemos sua mensagem."
      subtitle="Vamos responder o mais rápido possível."
      primaryCta={{ label: 'Ver blog', href: '/blog' }}
      secondaryCta={{ label: 'Voltar para Home', href: '/' }}
    />
  </div>
);

export default ObrigadoContatoPage;
